import { request } from '../request';

export const ollamaModelApi = {
  listOllamaModels: () => request('/ollama-models'),

  downloadOllamaModel: (body) =>
    request('/ollama-models/download', {
      method: 'POST',
      body: JSON.stringify(body)
    }),

  getOllamaDownloadStatus: () => request('/ollama-models/download-status'),

  cancelOllamaDownload: (taskId) =>
    request(`/ollama-models/download/${encodeURIComponent(taskId)}`, { method: 'DELETE' }),

  deleteOllamaModel: (name) => request(`/ollama-models/${encodeURIComponent(name)}`, { method: 'DELETE' })
};
